function show_warning(sender) {
    const $ = jQuery.noConflict();
    const elm = $(sender);

    const html = elm.next().html();

    foundationPopup('<h4>Waarschuwing:</h4>' + html + '<div class="text-center"><button class="button primary">Sluiten</button></div>', function(elm, popup) {
        elm.find('br:first').remove();
        elm.find("button").click(function(e) {
            e.preventDefault();
            popup.close();
        });
    }, "tiny");

}